/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export default function CmeIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg)">
      {' '}
      <path
        d="M3 20.4854C3 22.3926 3.98438 23.377 5.86523 23.377H14.0918C15.9727 23.377 16.957 22.3838 16.957 20.4854V18.8594H18.4512C20.332 18.8594 21.3164 17.8662 21.3164 15.9678V9.01562C21.3164 7.85547 21.0703 7.11719 20.376 6.40527L15.999 1.94043C15.3311 1.26367 14.54 1 13.5293 1H10.2246C8.34375 1 7.35938 1.99316 7.35938 3.90039V5.51758H5.86523C3.98438 5.51758 3 6.51953 3 8.41797V20.4854ZM16.0693 11.2393L11.3057 6.40527C10.6377 5.72852 10.0664 5.54395 9.1084 5.52637V4.00586C9.1084 3.20605 9.53027 2.75781 10.374 2.75781H14.0391V6.93262C14.0391 8.02246 14.6191 8.59375 15.7002 8.59375H19.5586V15.8535C19.5586 16.6621 19.1367 17.1104 18.293 17.1104H16.957V13.7354C16.957 12.5488 16.8076 11.9951 16.0693 11.2393ZM15.4893 6.71289V3.46973L19.1016 7.14355H15.9199C15.6123 7.14355 15.4893 7.02051 15.4893 6.71289ZM4.74902 20.3711V8.53223C4.74902 7.72363 5.1709 7.27539 6.02344 7.27539H8.7041V12.0566C8.7041 13.3311 9.32812 13.9463 10.5938 13.9463H15.208V20.3711C15.208 21.1797 14.7861 21.6279 13.9336 21.6279H6.01465C5.1709 21.6279 4.74902 21.1797 4.74902 20.3711ZM10.7607 12.4082C10.4004 12.4082 10.2422 12.2588 10.2422 11.8896V7.60938L14.9707 12.4082H10.7607Z"
        // fill="currentColor"
      />
    </SvgIcon>
  );
}

export function BookmarkIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg)">
      {' '}
      <path
        d="M18 5C18 4.73478 17.8946 4.48051 17.707 4.29297C17.5195 4.10543 17.2652 4 17 4H7C6.73478 4 6.48051 4.10543 6.29297 4.29297C6.10543 4.48051 6 4.73478 6 5V19.2764L11.5039 16.1318L11.6221 16.0742C11.9045 15.9589 12.2271 15.9781 12.4961 16.1318L18 19.2764V5ZM20 21C20 21.3565 19.8103 21.6863 19.502 21.8652C19.1937 22.0441 18.8134 22.045 18.5039 21.8682L12 18.1514L5.49609 21.8682C5.18663 22.045 4.80634 22.0441 4.49805 21.8652C4.18973 21.6863 4 21.3565 4 21V5C4 4.20435 4.3163 3.44152 4.87891 2.87891C5.44152 2.3163 6.20435 2 7 2H17C17.7956 2 18.5585 2.3163 19.1211 2.87891C19.6837 3.44152 20 4.20435 20 5V21Z"
        // fill="currentColor"
      />{' '}
    </SvgIcon>
  );
}
export function ConsumerQuickStartIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg)">
      {' '}
      <path
        d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C16.411 20 20 16.411 20 12C20 7.589 16.411 4 12 4C7.589 4 4 7.589 4 12C4 16.411 7.589 20 12 20ZM12 9C11.448 9 11 8.552 11 8C11 7.448 11.448 7 12 7C12.552 7 13 7.448 13 8C13 8.552 12.552 9 12 9ZM12 17C11.448 17 11 16.552 11 16L11 11C11 10.448 11.448 10 12 10C12.552 10 13 10.448 13 11L13 16C13 16.552 12.552 17 12 17Z"
        // fill="currentColor"
      />{' '}
    </SvgIcon>
  );
}
export function CreatorLogOutIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg)">
      {' '}
      {/* <path
        d="M7 4C7.55 4 8 4.45 8 5C8 5.55 7.55 6 7 6H6V18H7C7.55 18 8 18.45 8 19C8 19.55 7.55 20 7 20H5C4.45 20 4 19.55 4 19V5C4 4.45 4.45 4 5 4H7ZM16.6113 7.18164C17.0623 6.86295 17.686 6.97293 18.0039 7.4248L20.8184 11.4248C21.0682 11.7788 21.0597 12.2537 20.7998 12.5996L17.7998 16.5996C17.6038 16.8616 17.303 17 16.999 17C16.791 17 16.5794 16.9348 16.3994 16.7998C15.9577 16.4687 15.8693 15.8413 16.2002 15.4004L18.001 13H10C9.44807 13 9.00011 12.5529 9 12C9 11.447 9.448 11 10 11H18C18.03 11 18.056 11.0146 18.0859 11.0176L16.3682 8.5752C16.0502 8.1242 16.1593 7.49964 16.6113 7.18164Z"
        // fill="currentColor" */}
      <path
        d="M16.0588 13C16.8029 13 17.4122 13.6191 17.4122 14.3754C17.4119 15.1315 16.8028 15.7495 16.0588 15.7495H14.7054V32.2505H16.0588C16.8028 32.2505 17.4119 32.8686 17.4122 33.6247C17.4122 34.3809 16.8029 35 16.0588 35H13.3534C12.6092 35 12 34.3809 12 33.6247V14.3754C12 13.6191 12.6092 13 13.3534 13H16.0588ZM29.0617 17.3749C29.6719 16.9363 30.5161 17.0878 30.9463 17.7093L34.7536 23.2097C35.0916 23.6964 35.0805 24.349 34.7288 24.8247L30.67 30.3249C30.405 30.6848 29.9983 30.8749 29.5874 30.8751C29.306 30.8751 29.02 30.7855 28.7765 30.6C28.1785 30.1449 28.058 29.282 28.5058 28.6757L30.9429 25.3748H20.1176C19.3708 25.3748 18.7642 24.7598 18.7642 23.9994C18.7645 23.2392 19.3709 22.6253 20.1176 22.6253H30.9406C30.9812 22.6253 31.0169 22.645 31.0575 22.6493L28.7327 19.2901C28.3027 18.6701 28.4504 17.8121 29.0617 17.3749Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
export function KnowledgeHubIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg)">
      {' '}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 15.8889C13.7001 15.8889 15.8889 13.7001 15.8889 11C15.8889 8.29994 13.7001 6.11111 11 6.11111C8.29994 6.11111 6.11111 8.29994 6.11111 11C6.11111 13.7001 8.29994 15.8889 11 15.8889ZM11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z"
        fill="currentColor"
      />{' '}
    </SvgIcon>
  );
}
export function AffiliateAdminIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg)">
      {' '}
      <path
        d="M12.0557 14.2227C14.8425 14.2227 17.1111 16.4898 17.1113 19.2773C17.1113 19.676 16.7881 20 16.3887 20C15.9894 19.9999 15.667 19.6759 15.667 19.2773C15.6668 17.2864 14.0466 15.6671 12.0557 15.667C10.0646 15.667 8.44457 17.2864 8.44434 19.2773C8.44434 19.6759 8.12185 19.9998 7.72266 20C7.32327 20 7 19.676 7 19.2773C7.00023 16.4898 9.26875 14.2227 12.0557 14.2227ZM12.0547 7C13.6478 7 14.9442 8.29555 14.9443 9.88867C14.9443 11.4819 13.6479 12.7773 12.0547 12.7773C10.4616 12.7772 9.16602 11.4818 9.16602 9.88867C9.16613 8.29566 10.4617 7.00018 12.0547 7ZM12.0547 8.44434C11.2582 8.44439 10.6105 9.09219 10.6104 9.88867C10.6104 10.6852 11.2581 11.3329 12.0547 11.333C12.8513 11.333 13.499 10.6853 13.499 9.88867C13.4989 9.09216 12.8512 8.44434 12.0547 8.44434Z"
        // fill="currentColor"
      />{' '}
      <path
        d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C16.411 20 20 16.411 20 12C20 7.589 16.411 4 12 4C7.589 4 4 7.589 4 12C4 16.411 7.589 20 12 20Z"
        // fill="currentColor"
      />{' '}
    </SvgIcon>
  );
}
// export function SearchIcon(props: SvgIconProps) {
//   return (
//     <SvgIcon {...props} viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg)">
//       <path
//         d="M17.7068 16.1836L14.3118 12.8104C15.3648 11.4655 15.9998 9.77987 15.9998 7.94627C15.9998 3.5649 12.4108 0 7.99989 0C3.58895 0 0 3.5649 0 7.94627C0 12.3276 3.58895 15.8925 7.99989 15.8925C9.84586 15.8925 11.5428 15.2618 12.8968 14.2159L16.2928 17.5881C16.4878 17.7818 16.7438 17.8791 16.9998 17.8791C17.2558 17.8791 17.5118 17.7818 17.7068 17.5881C18.0977 17.1997 18.0977 16.5719 17.7068 16.1836Z"
//         fill="currentColor"
//       />{' '}
//       <path
//         d="M2.25 7.82208C2.25 4.74073 4.77278 2.23486 7.87492 2.23486C10.9771 2.23486 13.4998 4.74073 13.4998 7.82208C13.4998 10.9034 10.9771 13.4093 7.87492 13.4093C4.77278 13.4093 2.25 10.9034 2.25 7.82208Z"
//         fill="white"
//       />{' '}
//     </SvgIcon>
//   );
// }
export function SearchIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="-1 -1 20 20" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.7068 16.1836L14.3118 12.8104C15.3648 11.4655 15.9998 9.77987 15.9998 7.94627C15.9998 3.5649 12.4108 0 7.99989 0C3.58895 0 0 3.5649 0 7.94627C0 12.3276 3.58895 15.8925 7.99989 15.8925C9.84586 15.8925 11.5428 15.2618 12.8968 14.2159L16.2928 17.5881C16.4878 17.7818 16.7438 17.8791 16.9998 17.8791C17.2558 17.8791 17.5118 17.7818 17.7068 17.5881C18.0977 17.1997 18.0977 16.5719 17.7068 16.1836Z"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}

export function CreatorHomeIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 17C12 14.2386 14.2386 12 17 12C19.7614 12 22 14.2386 22 17C22 19.7614 19.7614 22 17 22C14.2386 22 12 19.7614 12 17ZM19.8571 17C19.8571 15.4221 18.578 14.1429 17 14.1429C15.4221 14.1429 14.1429 15.4221 14.1429 17C14.1429 18.578 15.4221 19.8571 17 19.8571C18.578 19.8571 19.8571 18.578 19.8571 17Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26 17C26 14.2386 28.2386 12 31 12C33.7614 12 36 14.2386 36 17C36 19.7614 33.7614 22 31 22C28.2386 22 26 19.7614 26 17ZM33.8571 17C33.8571 15.4221 32.5779 14.1429 31 14.1429C29.422 14.1429 28.1429 15.4221 28.1429 17C28.1429 18.578 29.422 19.8571 31 19.8571C32.5779 19.8571 33.8571 18.578 33.8571 17Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 31C12 28.2386 14.2386 26 17 26C19.7614 26 22 28.2386 22 31C22 33.7614 19.7614 36 17 36C14.2386 36 12 33.7614 12 31ZM19.8571 31C19.8571 29.422 18.578 28.1429 17 28.1429C15.4221 28.1429 14.1429 29.422 14.1429 31C14.1429 32.5779 15.4221 33.8571 17 33.8571C18.578 33.8571 19.8571 32.5779 19.8571 31Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26 31C26 28.2386 28.2386 26 31 26C33.7614 26 36 28.2386 36 31C36 33.7614 33.7614 36 31 36C28.2386 36 26 33.7614 26 31ZM33.8571 31C33.8571 29.422 32.5779 28.1429 31 28.1429C29.422 28.1429 28.1429 29.422 28.1429 31C28.1429 32.5779 29.422 33.8571 31 33.8571C32.5779 33.8571 33.8571 32.5779 33.8571 31Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export function DocumentsIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M31.5557 13.3335C32.292 13.3335 32.889 13.9305 32.889 14.6668V38.6668C32.889 39.4032 32.292 40.0002 31.5557 40.0002H12.889C12.1526 40.0002 11.5557 39.4032 11.5557 38.6668V14.6668C11.5557 13.9305 12.1526 13.3335 12.889 13.3335H31.5557ZM14.2223 37.3335H30.2223V16.0002H14.2223V37.3335Z"
        fill="currentColor"
      />
      <path
        d="M18.2222 9.3335H36.8888V33.3335H33.7777H30.6666H27.5555H24.4444H20.8888H18.2222V9.3335Z"
        fill="#EEF1F6"
      />
      <path
        d="M36.8889 8C37.6253 8 38.2222 8.59695 38.2222 9.33333V33.3333C38.2222 34.0697 37.6253 34.6667 36.8889 34.6667H18.2222C17.4859 34.6667 16.8889 34.0697 16.8889 33.3333V9.33333C16.8889 8.59695 17.4859 8 18.2222 8H36.8889ZM19.5556 32H35.5556V10.6667H19.5556V32Z"
        fill="currentColor"
      />
      <path
        d="M31.5555 13.3335C32.2919 13.3335 32.8888 13.9305 32.8888 14.6668C32.8888 15.4032 32.2919 16.0002 31.5555 16.0002H23.5555C22.8191 16.0002 22.2222 15.4032 22.2222 14.6668C22.2222 13.9305 22.8191 13.3335 23.5555 13.3335H31.5555Z"
        fill="currentColor"
      />
      <path
        d="M31.5555 18.6665C32.2919 18.6665 32.8888 19.2634 32.8888 19.9998C32.8888 20.7362 32.2919 21.3332 31.5555 21.3332H23.5555C22.8191 21.3332 22.2222 20.7362 22.2222 19.9998C22.2222 19.2634 22.8191 18.6665 23.5555 18.6665H31.5555Z"
        fill="currentColor"
      />
      <path
        d="M31.5556 24C32.292 24 32.8889 24.597 32.8889 25.3333C32.8889 26.0697 32.292 26.6667 31.5556 26.6667H26.2222C25.4859 26.6667 24.8889 26.0697 24.8889 25.3333C24.8889 24.597 25.4859 24 26.2222 24H31.5556Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export function EmbeddablesIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M35.9443 32.8389C36.6799 32.839 37.2725 33.4313 37.2725 34.167C37.2723 34.889 36.6816 35.495 35.9443 35.4951H20.8271C20.0862 35.4951 19.5109 34.8855 19.5107 34.167C19.5107 33.4348 20.0879 32.8389 20.8271 32.8389H35.9443ZM27.667 22.417C28.5412 22.4171 29.2498 23.1258 29.25 24V29.3457L29.2432 29.4824V29.4961C29.167 30.2409 28.574 30.8332 27.8291 30.9092L27.8154 30.9102L27.6787 30.917H12.9883L12.8516 30.9102L12.8379 30.9092C12.093 30.8332 11.501 30.2409 11.4248 29.4961L11.4238 29.4824L11.417 29.3457V24C11.4172 23.1258 12.1258 22.4172 13 22.417H27.667ZM13.917 28.417H26.75V24.917H13.917V28.417ZM35.9443 17.8906C36.6782 17.8908 37.2725 18.4696 37.2725 19.2188C37.2725 19.9409 36.6817 20.5467 35.9443 20.5469H20.8271C20.0861 20.5469 19.5107 19.9374 19.5107 19.2188C19.5107 18.4866 20.0879 17.8906 20.8271 17.8906H35.9443ZM35.9443 11.75C36.6782 11.7501 37.2725 12.329 37.2725 13.0781C37.2725 13.8003 36.6817 14.4061 35.9443 14.4062H20.8271C20.0861 14.4062 19.5107 13.7968 19.5107 13.0781C19.5107 12.346 20.0879 11.75 20.8271 11.75H35.9443Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export function DownArrowIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 16 9" sx={{ ...props.sx, fontSize: 'small' }}>
      <path
        d="M7.7959 8.98242C8.10352 8.97363 8.38477 8.85937 8.61328 8.61328L15.293 1.77539C15.4863 1.58203 15.5918 1.33594 15.5918 1.0459C15.5918 0.46582 15.1348 0 14.5547 0C14.2734 0 14.001 0.114258 13.7988 0.316406L7.80469 6.47754L1.79297 0.316406C1.59082 0.123047 1.32715 0 1.03711 0C0.457031 0 0 0.46582 0 1.0459C0 1.33594 0.105469 1.58203 0.298828 1.77539L6.9873 8.61328C7.22461 8.85938 7.48828 8.98242 7.7959 8.98242Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export function BrokenHeartsIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.8967 14.0157C20.5778 14.1356 22.3295 14.9424 24.0064 16.576L24.0097 16.5711L27.0164 19.1084L20.1783 25.8422L26.8507 31.7554L24.582 33.782C24.2555 34.0724 23.757 34.0729 23.4308 33.782L13.9743 25.3462C13.9641 25.3371 13.954 25.3278 13.9442 25.3182C10.9717 22.3911 11.716 18.1564 14.1065 15.8181C15.3214 14.6302 17.0001 13.8807 18.8967 14.0157ZM29.1128 14.0189C31.0076 13.8868 32.6825 14.6416 33.8946 15.8313C36.2779 18.1712 37.0275 22.4059 34.0703 25.3182C34.0605 25.3278 34.0487 25.3372 34.0385 25.3462L29.5478 29.3516L22.6679 25.7746L29.5361 19.0128L26.1647 14.9367C27.1526 14.3841 28.1442 14.0867 29.1128 14.0189Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export function ManageReviewersIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M24 11C31.1797 11 37 16.8203 37 24C37 31.1797 31.1797 37 24 37C16.8203 37 11 31.1797 11 24C11 16.8203 16.8203 11 24 11ZM24 29.5732C22.5674 29.5734 21.1577 29.942 19.9085 30.6433C18.8944 31.2129 18.0137 31.9899 17.3186 32.9157C19.1805 34.3132 21.4928 35.1428 24 35.1428C26.5066 35.1428 28.8179 34.3127 30.6795 32.9157C29.9847 31.9903 29.1069 31.2127 28.0934 30.6433C26.8439 29.9415 25.433 29.5734 24 29.5732ZM24 12.8572C17.846 12.8572 12.8572 17.846 12.8572 24C12.8572 26.9769 14.0275 29.6783 15.9294 31.677C16.7633 30.6009 17.8043 29.6962 18.998 29.0256C20.5252 28.1679 22.2485 27.7163 24 27.7161C25.7519 27.7163 27.4764 28.1675 29.0038 29.0256C30.197 29.696 31.235 30.6014 32.0688 31.677C33.9712 29.6782 35.1428 26.9773 35.1428 24C35.1428 17.846 30.154 12.8572 24 12.8572ZM24 15.6428C27.077 15.6428 29.5715 18.1373 29.5715 21.2143C29.5715 24.2913 27.077 26.7857 24 26.7857C20.923 26.7857 18.4285 24.2913 18.4285 21.2143C18.4285 18.1373 20.923 15.6428 24 15.6428ZM24 17.5C21.9487 17.5 20.2857 19.1629 20.2857 21.2143C20.2857 23.2656 21.9487 24.9285 24 24.9285C26.0513 24.9285 27.7143 23.2656 27.7143 21.2143C27.7143 19.1629 26.0513 17.5 24 17.5Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
export function FeedbackAdminIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M33.1 11C35.2502 11 37 12.7711 37 14.9474V28.1053C37 30.2816 35.2502 32.0526 33.1 32.0526H19.5198C19.2848 32.0528 19.0534 32.1167 18.8508 32.2403L12.969 35.8124C12.7625 35.9384 12.5311 36 12.3 36C12.079 36 11.8577 35.9435 11.6588 35.8291C11.2521 35.5962 11 35.1579 11 34.6842V14.9474C11 12.7711 12.7498 11 14.9 11H33.1ZM14.9 13.6316C14.1837 13.6316 13.6 14.2224 13.6 14.9474V32.3611L17.5127 29.9838C18.1197 29.6155 18.814 29.4212 19.5198 29.4211H33.1C33.8163 29.4211 34.4 28.8303 34.4 28.1053V14.9474C34.4 14.2224 33.8163 13.6316 33.1 13.6316H14.9Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export function FeedbackIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M33.1 11C35.2502 11 37 12.7711 37 14.9474V28.1053C37 30.2816 35.2502 32.0526 33.1 32.0526H19.5198C19.2848 32.0528 19.0534 32.1167 18.8508 32.2403L12.969 35.8124C12.7625 35.9384 12.5311 36 12.3 36C12.079 36 11.8577 35.9435 11.6588 35.8291C11.2521 35.5962 11 35.1579 11 34.6842V14.9474C11 12.7711 12.7498 11 14.9 11H33.1ZM14.9 13.6316C14.1837 13.6316 13.6 14.2224 13.6 14.9474V32.3611L17.5127 29.9838C18.1197 29.6155 18.814 29.4212 19.5198 29.4211H33.1C33.8163 29.4211 34.4 28.8303 34.4 28.1053V14.9474C34.4 14.2224 33.8163 13.6316 33.1 13.6316H14.9ZM18.8 20.2105C19.5176 20.2105 20.1 20.8 20.1 21.5263C20.1 22.2526 19.5176 22.8421 18.8 22.8421C18.0824 22.8421 17.5 22.2526 17.5 21.5263C17.5 20.8 18.0824 20.2105 18.8 20.2105ZM24 20.2105C24.7176 20.2105 25.3 20.8 25.3 21.5263C25.3 22.2526 24.7176 22.8421 24 22.8421C23.2824 22.8421 22.7 22.2526 22.7 21.5263C22.7 20.8 23.2824 20.2105 24 20.2105ZM29.2 20.2105C29.9176 20.2105 30.5 20.8 30.5 21.5263C30.5 22.2526 29.9176 22.8421 29.2 22.8421C28.4824 22.8421 27.9 22.2526 27.9 21.5263C27.9 20.8 28.4824 20.2105 29.2 20.2105Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export function CreatorIndexIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13 21C14.6569 21 16 22.3431 16 24C16 25.6569 14.6569 27 13 27C11.3431 27 10 25.6569 10 24C10 22.3431 11.3431 21 13 21ZM24 21C25.6569 21 27 22.3431 27 24C27 25.6569 25.6569 27 24 27C22.3431 27 21 25.6569 21 24C21 22.3431 22.3431 21 24 21ZM35 21C36.6569 21 38 22.3431 38 24C38 25.6569 36.6569 27 35 27C33.3431 27 32 25.6569 32 24C32 22.3431 33.3431 21 35 21Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
export function QuickMenuKnowledgeHubIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M36.0001 18.6665L36.1368 18.6731C36.809 18.7415 37.3334 19.3096 37.3334 19.9999V35.1665C37.3334 35.8568 36.809 36.4249 36.1368 36.4934L36.0001 36.4999H35.9727C35.9503 36.5001 35.9148 36.5015 35.8673 36.5025C35.772 36.5045 35.628 36.5082 35.4428 36.5168C35.0721 36.534 34.5372 36.5683 33.8933 36.6379C32.5986 36.7778 30.8954 37.0556 29.211 37.6014C27.4939 38.1579 26.3819 38.7044 25.7214 39.0897C25.3914 39.2822 25.1735 39.4351 25.0483 39.5298C24.9858 39.5771 24.9461 39.6099 24.9272 39.6262C24.9195 39.6328 24.9141 39.6379 24.9141 39.6379L24.9285 39.6236C24.5443 39.9963 23.9737 40.1028 23.4806 39.8944C22.9873 39.6857 22.6667 39.2022 22.6667 38.6665V23.4999C22.6667 23.1399 22.8123 22.7952 23.0704 22.5441L23.0743 22.5402C23.0743 22.5402 23.078 22.5378 23.0795 22.5363C23.0825 22.5334 23.085 22.5293 23.0886 22.5259C23.0959 22.5191 23.105 22.5113 23.1147 22.5025C23.1344 22.4844 23.16 22.462 23.1902 22.4361C23.251 22.3839 23.3341 22.3157 23.4402 22.2356C23.6523 22.0752 23.9584 21.8629 24.3777 21.6184C25.2172 21.1287 26.5066 20.5085 28.3894 19.8983C30.3049 19.2776 32.2016 18.972 33.6069 18.8202C34.3125 18.744 34.9024 18.7054 35.3191 18.6861C35.5276 18.6764 35.6943 18.6716 35.81 18.6691C35.8676 18.6679 35.9134 18.6669 35.9454 18.6665H36.0001ZM33.8933 21.4712C32.5986 21.6111 30.8954 21.8889 29.211 22.4348C27.4939 22.9913 26.3819 23.5378 25.7214 23.9231C25.5685 24.0123 25.4401 24.0936 25.3334 24.1639V36.2772C26.1089 35.8978 27.1126 35.4788 28.3894 35.065C30.3049 34.4442 32.2016 34.1387 33.6069 33.9869C33.9992 33.9445 34.3558 33.914 34.6667 33.8918V21.3996C34.4326 21.4181 34.1732 21.441 33.8933 21.4712Z"
        fill="currentColor"
      />
      <path
        d="M11.9998 18.6665L11.8631 18.6731C11.1909 18.7415 10.6665 19.3096 10.6665 19.9999V35.1665C10.6665 35.8568 11.1909 36.4249 11.8631 36.4934L11.9998 36.4999H12.0272C12.0496 36.5001 12.0851 36.5015 12.1326 36.5025C12.2279 36.5045 12.3719 36.5082 12.5571 36.5168C12.9278 36.534 13.4627 36.5683 14.1066 36.6379C15.4013 36.7778 17.1045 37.0556 18.7889 37.6014C20.506 38.1579 21.618 38.7044 22.2785 39.0897C22.6085 39.2822 22.8264 39.4351 22.9516 39.5298C23.0141 39.5771 23.0538 39.6099 23.0727 39.6262C23.0804 39.6328 23.0858 39.6379 23.0858 39.6379L23.0714 39.6236C23.4556 39.9963 24.0262 40.1028 24.5193 39.8944C25.0126 39.6857 25.3332 39.2022 25.3332 38.6665V23.4999C25.3332 23.1399 25.1876 22.7952 24.9295 22.5441L24.9256 22.5402C24.9256 22.5402 24.9219 22.5378 24.9204 22.5363C24.9174 22.5334 24.9149 22.5293 24.9113 22.5259C24.904 22.5191 24.8949 22.5113 24.8852 22.5025C24.8655 22.4844 24.8399 22.462 24.8097 22.4361C24.7489 22.3839 24.6658 22.3157 24.5597 22.2356C24.3476 22.0752 24.0415 21.8629 23.6222 21.6184C22.7827 21.1287 21.4933 20.5085 19.6105 19.8983C17.695 19.2776 15.7983 18.972 14.393 18.8202C13.6874 18.744 13.0975 18.7054 12.6808 18.6861C12.4723 18.6764 12.3056 18.6716 12.1899 18.6691C12.1323 18.6679 12.0865 18.6669 12.0545 18.6665H11.9998ZM14.1066 21.4712C15.4013 21.6111 17.1045 21.8889 18.7889 22.4348C20.506 22.9913 21.618 23.5378 22.2785 23.9231C22.4314 24.0123 22.5598 24.0936 22.6665 24.1639V36.2772C21.891 35.8978 20.8873 35.4788 19.6105 35.065C17.695 34.4442 15.7983 34.1387 14.393 33.9869C14.0007 33.9445 13.6441 33.914 13.3332 33.8918V21.3996C13.5673 21.4181 13.8267 21.441 14.1066 21.4712Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.2966 11.2596C25.6039 11.2596 26.667 12.3227 26.667 13.6299C26.667 14.9372 25.6039 16.0003 24.2966 16.0003C22.9894 16.0003 21.9263 14.9372 21.9263 13.6299C21.9263 12.3227 22.9894 11.2596 24.2966 11.2596ZM24.2964 18.3707C26.9109 18.3707 29.0371 16.2445 29.0371 13.6299C29.0371 11.0154 26.9109 8.88916 24.2964 8.88916C21.6819 8.88916 19.5557 11.0154 19.5557 13.6299C19.5557 16.2445 21.6819 18.3707 24.2964 18.3707Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
export function WidgetsIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M35.7 11H12.3C11.9552 11 11.6245 11.137 11.3808 11.3808C11.137 11.6245 11 11.9552 11 12.3V35.7C11 36.0448 11.137 36.3755 11.3808 36.6192C11.6245 36.863 11.9552 37 12.3 37H35.7C36.0448 37 36.3755 36.863 36.6192 36.6192C36.863 36.3755 37 36.0448 37 35.7V12.3C37 11.9552 36.863 11.6245 36.6192 11.3808C36.3755 11.137 36.0448 11 35.7 11ZM22.7 34.4H13.6V29.2H22.7V34.4ZM22.7 26.6H13.6V21.4H22.7V26.6ZM34.4 34.4H25.3V29.2H34.4V34.4ZM34.4 26.6H25.3V21.4H34.4V26.6ZM34.4 18.8H13.6V13.6H34.4V18.8Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
export function ConsumerHomeIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 5.52941C1 3.02789 3.02789 1 5.52941 1C8.03094 1 10.0588 3.02789 10.0588 5.52941C10.0588 8.03094 8.03094 10.0588 5.52941 10.0588C3.02789 10.0588 1 8.03094 1 5.52941ZM8.11765 5.52941C8.11765 4.09997 6.95885 2.94118 5.52941 2.94118C4.09997 2.94118 2.94118 4.09997 2.94118 5.52941C2.94118 6.95885 4.09997 8.11765 5.52941 8.11765C6.95885 8.11765 8.11765 6.95885 8.11765 5.52941Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.9412 5.52941C13.9412 3.02789 15.9691 1 18.4706 1C20.9721 1 23 3.02789 23 5.52941C23 8.03094 20.9721 10.0588 18.4706 10.0588C15.9691 10.0588 13.9412 8.03094 13.9412 5.52941ZM21.0588 5.52941C21.0588 4.09997 19.9 2.94118 18.4706 2.94118C17.0411 2.94118 15.8824 4.09997 15.8824 5.52941C15.8824 6.95885 17.0411 8.11765 18.4706 8.11765C19.9 8.11765 21.0588 6.95885 21.0588 5.52941Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 18.4706C1 15.9691 3.02789 13.9412 5.52941 13.9412C8.03094 13.9412 10.0588 15.9691 10.0588 18.4706C10.0588 20.9721 8.03094 23 5.52941 23C3.02789 23 1 20.9721 1 18.4706ZM8.11765 18.4706C8.11765 17.0411 6.95885 15.8824 5.52941 15.8824C4.09997 15.8824 2.94118 17.0411 2.94118 18.4706C2.94118 19.9 4.09997 21.0588 5.52941 21.0588C6.95885 21.0588 8.11765 19.9 8.11765 18.4706Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.9412 18.4706C13.9412 15.9691 15.9691 13.9412 18.4706 13.9412C20.9721 13.9412 23 15.9691 23 18.4706C23 20.9721 20.9721 23 18.4706 23C15.9691 23 13.9412 20.9721 13.9412 18.4706ZM21.0588 18.4706C21.0588 17.0411 19.9 15.8824 18.4706 15.8824C17.0411 15.8824 15.8824 17.0411 15.8824 18.4706C15.8824 19.9 17.0411 21.0588 18.4706 21.0588C19.9 21.0588 21.0588 19.9 21.0588 18.4706Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
export const ConsumerLogoutIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg)">
    {' '}
    <path
      d="M7 4C7.55 4 8 4.45 8 5C8 5.55 7.55 6 7 6H6V18H7C7.55 18 8 18.45 8 19C8 19.55 7.55 20 7 20H5C4.45 20 4 19.55 4 19V5C4 4.45 4.45 4 5 4H7ZM16.6113 7.18164C17.0623 6.86295 17.686 6.97293 18.0039 7.4248L20.8184 11.4248C21.0682 11.7788 21.0597 12.2537 20.7998 12.5996L17.7998 16.5996C17.6038 16.8616 17.303 17 16.999 17C16.791 17 16.5794 16.9348 16.3994 16.7998C15.9577 16.4687 15.8693 15.8413 16.2002 15.4004L18.001 13H10C9.44807 13 9.00011 12.5529 9 12C9 11.447 9.448 11 10 11H18C18.03 11 18.056 11.0146 18.0859 11.0176L16.3682 8.5752C16.0502 8.1242 16.1593 7.49964 16.6113 7.18164Z"
      fill="currentColor"
    />{' '}
  </SvgIcon>
);
export const CreatorQuickStartIcon = (props: SvgIconProps) => (
  <SvgIcon
    {...props}
    // width="48"
    // height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg)"
  >
    <path
      d="M23.5 38C16.044 38 10 31.956 10 24.5C10 17.0439 16.044 11 23.5 11C30.9561 11 37 17.044 37 24.5C37 31.956 30.956 38 23.5 38ZM23.5 35.2998C29.4548 35.2998 34.2998 30.4548 34.2998 24.5C34.2998 18.5452 29.4549 13.7002 23.5 13.7002C17.5452 13.7002 12.7002 18.5451 12.7002 24.5C12.7002 30.4548 17.5452 35.2998 23.5 35.2998ZM23.499 20.4502C22.7542 20.4497 22.1494 19.8445 22.1494 19.0996C22.1496 18.3549 22.7544 17.7505 23.499 17.75C24.2441 17.75 24.8494 18.3546 24.8496 19.0996C24.8496 19.8448 24.2442 20.4502 23.499 20.4502ZM23.5 31.25C22.7551 31.2498 22.1496 30.6453 22.1494 29.9004L22.1494 23.1504C22.1494 22.4053 22.755 21.8 23.5 21.7998C24.245 21.8 24.8496 22.4053 24.8496 23.1504L24.8496 29.9004C24.8494 30.6453 24.2449 31.2498 23.5 31.25Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export function UserIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M24 24.5C28.004 24.5 31.25 21.254 31.25 17.25C31.25 13.246 28.004 10 24 10C19.996 10 16.75 13.246 16.75 17.25C16.75 21.254 19.996 24.5 24 24.5Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5 38C11.5 32.753 16.253 28.5 24 28.5C31.747 28.5 36.5 32.753 36.5 38"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
export function TestEnvIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 48 48">
      <path
        d="M14 8h14l8 8v18a6 6 0 0 1-6 6H14a6 6 0 0 1-6-6V14a6 6 0 0 1 6-6zm12 2H14a4 4 0 0 0-4 4v20a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4V17h-8a2 2 0 0 1-2-2V10zm-10 12h10v2H16v-2zm0 6h10v2H16v-2zm18 2a6 6 0 1 1-12 0 6 6 0 0 1 12 0zm-7 1.5 2 2 4-4-1.4-1.4-2.6 2.6-0.6-0.6-1.4 1.4z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
